let loginMfaContext = null;

function sanitizeRememberForDays(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return parsed;
}

export function setLoginMfaContext(context) {
  if (!context || !context.username || !context.password) {
    loginMfaContext = null;
    return;
  }

  loginMfaContext = {
    username: String(context.username),
    password: String(context.password),
    rememberMfa: Boolean(context.rememberMfa),
    mfaRememberForDays: sanitizeRememberForDays(context.mfaRememberForDays)
  };
}

export function updateLoginMfaContext(update) {
  if (!loginMfaContext || !update || typeof update !== "object") {
    return;
  }

  loginMfaContext = {
    ...loginMfaContext,
    ...update,
    rememberMfa: Boolean(update.rememberMfa !== undefined ? update.rememberMfa : loginMfaContext.rememberMfa),
    mfaRememberForDays: sanitizeRememberForDays(update.mfaRememberForDays !== undefined ? update.mfaRememberForDays : loginMfaContext.mfaRememberForDays)
  };
}

export function getLoginMfaContext() {
  if (!loginMfaContext) {
    return null;
  }

  return { ...loginMfaContext };
}

export function clearLoginMfaContext() {
  loginMfaContext = null;
}



// WEBPACK FOOTER //
// ./utils/loginMfaContext.js